import { apple } from "./os.js";
const voiceOver = apple;
export {
  voiceOver
};
//# sourceMappingURL=screen-reader.js.map
